<template>
  <v-card outlined>
    <v-toolbar class="elevation-0" height="45" color="gray">
      <v-toolbar-title>
        <h1 class="subtitle-1">{{ $t("labels.dueDate") }}</h1>
      </v-toolbar-title>
    </v-toolbar>
    <v-card-text class="pa-0">
      <v-card color="blue darken-1" flat tile dark="dark">
        <v-card-text>
          <v-layout column>
            <v-layout row wrap>
              <v-flex class="font-weight-regular">
                <div class="text-center">
                  <span class="font-weight-medium">{{ service.dueDate }} |</span>
                  <span class="ml-2">
                    <v-chip small v-if="dueDateCount < minDay">
                      <span class="font-weight-medium">{{ dueDateCount }} days</span>
                    </v-chip>
                    <v-chip small color="#ffd0d2" text-color="#ff3840" v-else>
                      <span class="font-weight-medium">{{ dueDateCount }} days</span>
                    </v-chip>
                  </span>
                </div>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    service: {
      default: {}
    },
    minDay: {
      default: 5
    }
  },
  data() {
    return {
      locationDueDate: null
    };
  },
  computed: {
    ...mapGetters("global", ["checkRightStatus"]),
    ...mapGetters("location", ["location"]),
    dueDateCount() {
      return this.$moment(this.service.dueDate).diff(this.$moment().format("MM/DD/YYYY"), "day");
    },
    NewDueDateCount() {
      return this.$moment(this.locationDueDate).diff(this.$moment().format("MM/DD/YYYY"), "day");
    }
  }
};
</script>
